const Search = require('./search/search');

new Search.Search();



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/public/js/frontend/src/main.js